import type { FC } from 'react'
import { useState } from 'react'

import { useMutation, useQuery } from '@tanstack/react-query'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import buyoutResources from '@/api/buyout'
import queries from '@/api/queries'
import BuyoutContent from '@/components/buyout/BuyoutContent'
import Page from '@/components/page/Page'
import { getDevicePolicy } from '@/ducks/devicePolicyReducer'
import useUser from '@/hooks/user'
import { APP_ROUTES } from '@/util/appRoutes'

import { Translation } from '../i18n/Translation'

import './buyout.scss'

const Buyout: FC = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const user = useUser()

  const [isBoughtOut, setIsBoughtOut] = useState(false)

  const { data } = useQuery(queries.buyout(), buyoutResources.get, {
    onSuccess({ buyoutPrice }) {
      if (buyoutPrice <= 0) navigate(APP_ROUTES.shop)
    },
  })

  const buyoutMutation = useMutation(buyoutResources.post, {
    onSuccess() {
      setIsBoughtOut(true)
      // @ts-ignore
      dispatch(getDevicePolicy(user?.code))
    },
  })

  if (!data) return null
  const { assetName, buyoutPrice } = data

  return (
    <Page className="buyout" onSwipedLeft={() => navigate(APP_ROUTES.shop)}>
      <h2 className="text-2xl">
        <Translation id="Utkjøp av telefon" />
      </h2>

      <BuyoutContent
        assetName={assetName}
        buyoutPrice={buyoutPrice}
        isLoading={buyoutMutation.isLoading}
        isBoughtOut={isBoughtOut}
        buyOut={buyoutMutation.mutate}
      />
    </Page>
  )
}

export default Buyout
